import { Box, Inline, Text, xcss } from '@atlaskit/primitives';
import Toggle from '@atlaskit/toggle';
import { FieldTypeIcon } from '@databases/icons/FieldTypeIcon';
import { DatabaseField } from '@databases/types/database';
import { shouldShowField } from '@databases/types/database/view';
import React from 'react';

import useView from '../../hooks/useView';

const fieldRowStyles = xcss({
  marginInlineStart: 'space.150',
});

export interface FieldOptionProps {
  field: DatabaseField;
  handleToggleField: (field: DatabaseField) => void;
}

export const FieldOption: React.FC<FieldOptionProps> = ({ field, handleToggleField }) => {
  const { view } = useView();
  const id = `field-toggle-${field.id}`;

  return (
    <Inline spread="space-between" alignBlock="center" xcss={fieldRowStyles}>
      <Inline alignBlock="center" space="space.100">
        <FieldTypeIcon type={field.type} noTooltip />
        <label htmlFor={id}>
          <Text maxLines={1}>{field.name}</Text>
        </label>
      </Inline>
      <Box>
        <Toggle
          id={id}
          testId="field-toggle"
          isChecked={shouldShowField(view.settings.fields, field.id)}
          onChange={() => handleToggleField(field)}
        />
      </Box>
    </Inline>
  );
};

export default FieldOption;
